import { Injectable} from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from './login/login.service';
import { Router} from '@angular/router';
import { CatalogosService } from './catalogos/catalogos.service';
import { SessionSotrageService } from './session-sotrage.service';
import { User } from 'src/app/model/session/user.model';
import { Location } from '@angular/common';
import { passwordPolicy } from 'src/app/common/vPassword/passwordPolicy';
import { vPasswordConst } from 'src/app/common/enum/vPassword.enum';
import { EnumGlobals } from 'src/app/common/enum/TipoPersona.enum';

@Injectable({
  providedIn: 'root'
})

export class SweetServices {

  loginForm = {
    Login: '',
    Password: '',
    Token: '',
    Bloqueo: false
  };

  LimitRequest:number = EnumGlobals.LimitRequest;
  route: string;
  public user: User;
  vpassword:passwordPolicy;
  public LimiteRequest:number;

  constructor(private loginService: LoginService,
              private catalogoService: CatalogosService,
              private router: Router,
              private sssotrage: SessionSotrageService,
              private location: Location, 
              private passwordPolicy:passwordPolicy) {
    this.route = '';
    this.user= new User();
    this.vpassword = passwordPolicy;
  }

  public AlertaConfirm(msg: string) {
    Swal.fire({
      type: 'success',
      title: msg,
      showConfirmButton: true
    });
  }

  public AlertaErrorTimer(msg: string) {
    Swal.fire({
      type: 'error',
      title: msg,
      showConfirmButton: false,
      timer: 1500
    });
  }

  public AlertaError(msg: string) {
    Swal.fire({
      type: 'error',
      title: 'Error',
      text: msg
    });
  }

  public AlertaInfo(msg: string) {
    Swal.fire({
      type: 'info',
      title: 'Sin Resultados',
      text: msg
    });
  }

  public AlertaSuccess(msg: string) {
    Swal.fire({
      type: 'info',
      text: msg
    });
  }

  public AlertaAdvertencia(msg: string) {
    Swal.fire({
      type: 'info',
      title: 'Advertencia',
      text: msg
    });
  }

  public AlertaInfoBuzon(msg: string) {
    Swal.fire({
      type: 'info',
      title: 'Dictamen',
      text: msg
    });
  }

  public AlertaTituloInfo(titulo: string, msg: string) {
    Swal.fire({
      type: 'info',
      title: titulo,
      text: msg
    });
  }

  public alertaInfo(msg: string) {
    Swal.fire({
      type: 'info',
      text: msg,
    });
  }

  public AlertaSuccessTimer(msg: string) {
    Swal.fire({
      type: 'success',
      title: msg,
      showConfirmButton: false,
      timer: 3000
    });
  }

  public AlertaSuccessUser(msg: string) {
    Swal.fire({
      type: 'success',
      title: msg,
      showConfirmButton: true

    });
  }

  public AlertaSinResultados(msg: string) {
    Swal.fire({
      type: 'info',
      title: msg,
      showConfirmButton: false,
      timer: 3000
    });
  }

  public AlertaToastSuccess(msg: string) {
   const Toast = Swal.mixin({
     toast: true,
     position: 'top-right',
     showConfirmButton: false,
     timer: 3000
    });

   Toast.fire({
     type: 'success',
     title: msg
   });
  }

  public AlertaToastError(msg: string) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-right',
      showConfirmButton: false,
      timer: 3000
     });

    Toast.fire({
      type: 'error',
      title: msg
    });
  }

  public AlertaCatch(error: any){
    console.log(error);
    let msg = '';
    if(error.statusText == 'Unknown Error'){
      msg = 'Existe un error al intentar acceder al recurso.';
    }
    else if( error.statusText == 'Bad Request' || error.status == 400) {
      msg = 'Existe un error de formato en la petición.'
    } else if(error.status == 401){
      msg = 'Solicitud no autorizada.'
    }

    Swal.fire({
      type: 'error',
      title: 'Error',
      text: msg
    });
  }

  public AlertaToastSinResultados(msg: string) {
    const Toast = Swal.mixin({
     toast: true,
     position: 'bottom-start',
     showConfirmButton: false,
     timer: 3500
   });

    Toast.fire({
     type: 'info',
     title: msg
   });
  }

  public AlertaCambioPassword(
    usuario: number, 
    router: Router, 
    message:string, 
    header:string, 
    confirmMessage:string) {
    this.LimiteRequest = EnumGlobals.LimitRequest;  
    var content = vPasswordConst.CHANGE_PASS_FORM.replace(
      vPasswordConst.AUX_TEXT_TO_REPLACE,message
    );
    Swal.fire({
      title: header,
      html: content,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Modificar',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const password = (
          Swal.getPopup()!.querySelector('#password') as HTMLInputElement
        ).value;
        const confirmPassword = (
          Swal.getPopup()!.querySelector('#confirmPassword') as HTMLInputElement
        ).value;
  
        const user = {
          UsuarioId: usuario,
          Password: password,
          ConfirmPassword: confirmPassword,
          Bloqueo: false,
          RolId: -1
        };
  
        this.ReestablecerPassword(user, router, confirmMessage);
      },
      allowOutsideClick: () => !Swal.isLoading(),
      onOpen: () => {
        const pass = Swal.getPopup()!.querySelector('#password') as HTMLInputElement;
        const confirmPass = Swal.getPopup()!.querySelector('#confirmPassword') as HTMLInputElement;
  
        pass.addEventListener('input', () => this.validatePassword(
          pass.value, confirmPass.value)
        );
        confirmPass.addEventListener('input', () => this.validatePassword(
          pass.value, confirmPass.value)
        );
      }
    });
  }

  public validatePassword(pass:string, confirmPass:string){
    const confirmButton = Swal.getConfirmButton() as HTMLButtonElement;
    const validationMessageElement = Swal.getPopup()!.querySelector
      ('#validationMessage') as HTMLDivElement;
    var response = this.vpassword.vPassword(pass, confirmPass);
    validationMessageElement.style.display = response.isValid?'none':'block';
    validationMessageElement.textContent = response.message;
    confirmButton.disabled = !response.isValid;
  }

  public AlertaRecargarToken() {
    this.sssotrage.setActivateAlert(1);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
      title: 'Tu sesión está por terminar.',
      text: '¿Deseas seguir Conectado?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      timer: 180000,
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.loginForm.Login = this.sssotrage.getCurrentUser().login;
        this.loginForm.Password = this.sssotrage.getPasswordSession();
        this.loginForm.Token = this.sssotrage.getCurrentToken();
        this.deshabilitarLogueado();
        this.sssotrage.setActivateAlert(0);
        this.loginService.iniciarSesion(this.loginForm).subscribe(response => {
          if (response === null) {
            // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
          } else if (response.isCorrect === 'false') {
             // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
          } else {
            this.correctLogin(response.data.info.result);
          }
        }, (err) => {
          if (err.error.message == null) {
            // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
          } else {
            // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
          }
        }
        );

      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.cerrarSesion();
      }
    });
  }

  public stringFormat(format: string, ...args: any[]): string {
    return format.replace(/{(\d+)}/g, (match, index) => {
      const arg = args[index];
      return arg !== undefined ? arg : match;
    });
  }

  public ReestablecerPassword(objPassword:any, router:any, confirmMessage:string){
    this.loginService.modificarPassword(objPassword).subscribe(response => {
      if (response === null) {
        this.AlertaError(
          'Existe un error, si persiste contacte al administrador del Sitio.'
        );
      } else if (response.isCorrect === 'false') {
        this.AlertaError(response.message);
      } else {
        this.AlertaSuccessTimer(confirmMessage);
        this.catalogoService.limpiarCatalogos(true);
        setTimeout(() => {
          router.navigate(['v2']);
        }, 2000);
      }
    }, (err) => {
      
      if(err.status == 401){
        if(this.LimiteRequest > 0){
          this.LimiteRequest = this.LimiteRequest - 1;
          this.ReestablecerPassword(objPassword, router, confirmMessage);
        }else {
          this.AlertaCatch(err);
        }
      }else{
        this.AlertaError(JSON.stringify(err));
      }
    });
  }

  cerrarSesion(): void {
    this.LimiteRequest = EnumGlobals.LimitRequest;  
    this.user = this.sssotrage.getCurrentUser();
    this.deshabilitarLogin.Login = this.user.login;
    this.deshabilitarLogueado();
    this.catalogoService.limpiarCatalogos(false);
    this.sssotrage.setActivateAlert(0);
    this.sssotrage.logout();
  
  }

  deshabilitarLogueado() {
    this.user = this.sssotrage.getCurrentUser();
      this.loginService.deshabilitarLogueado(this.deshabilitarLogin).subscribe(response => {
        if (response === null) {
          // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
        } else if (response.isCorrect === 'false') {
          // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
        }
      }, (err) => {
        if(err.status == 401){
          if(this.LimitRequest > 0){
            this.LimitRequest = this.LimitRequest - 1;
            this.deshabilitarLogueado();
          }else {
            // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
          // this.AlertaCatch('Solicitud no autorizada.');
        }
      } else {
        // ToDo: Mantener siguiente línea. Sólo se comentó para no generar
          //       error, pero debe diseñarse una mejor solución
        // this.AlertaCatch(err);
      }
      }
      );
  }

  deshabilitarLogin = {
    Login: ''
  };

  public ValidarToken() {
    this.AlertaRecargarToken();
  }

  private correctLogin(data: User) {
    this.sssotrage.setCurrentSession(data);
    this.router.navigate([this.location.path()]);
    this.sssotrage.setActivateAlert(0);
  }

}
